export default "__VITE_ASSET__DIytasYi__"